import React from "react";
import {ConfirmModal} from "../utils/Modal";
import Button from "@mui/material/Button";

export default class ActionValleyTrust extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            actions: props.actions[props.userId][0],
            show: false
        };
    }

    componentDidMount() {
    }
    styleButton = {
        backgroundColor: "#444",
        padding: "5px",
        borderRadius: "3px",
        marginTop: "6px",
        marginBottom: "6px",
        marginLeft: "10%",
        width: "80%"
    };

    render() {
        let modal = <ConfirmModal
            action={this.state.show ? this.state.action : undefined}
            text={"Confirmez-vous le choix de ce prélude ?"}
            socket={this.props.socket}
            onDismiss={() => this.setState({show: false})}
            open={this.state.show}
        />;
        return <div
            style={{
                margin: "0", overflow: "hidden", width: "100%", height: "100%", color: "#DDD",
                display: "flex", flexDirection: "column"
            }}>
            {modal}
            <div style={{flex: 1, fontSize: "20px", alignItems: "center", display: "flex", marginLeft: "20px"}}>
                Quel prélude voulez-vous choisir ?
            </div>
            <div style={{flex: 5, overflowX: "scroll", whiteSpace: "nowrap", marginLeft: "5%", width: "95%"}}>
                {
                    this.props.actions[this.props.userId].map(action =>
                        <div key={action.preludeId}
                             style={{height: "100%", display: "inline-block", marginLeft: "12px"}}>
                            <img src={"/public/terraforming/preludes/prelude_" + action.preludeId + ".png"}
                                 alt={"img " + action.preludeId}
                                 style={{width: "auto", height: "30vh"}}>
                            </img>
                            <br/>
                            <Button variant={"contained"}
                                    disabled={!action.ok}
                                    onClick={() => this.setState({action, show: true})}>
                                Choisir
                            </Button>
                        </div>
                    )
                }
            </div>
        </div>
    }
}
